import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import DashboardCalendar from "../dashboard/DashboardCalendar";
import PostComments from "./PostComments";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import ReplyModal from "./ReplyModal";
import "./forum.scss";
import Modal from "../../../Other/Modal";
import { useNavigate } from "react-router-dom";
const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
};
export default function Forums() {
  const { REACT_APP_LOGIN_API_BASEURL } = process.env;
  const navigate = useNavigate();
  const [fetchStatusJustAddedCourse, setFetchStatusJustAddedCourse] = useState(true);
  const [isloading, setIsLoading] = useState(true);
  const [dataIndex, setDataIndex] = useState(5);
  const [forumsHeaderDetails, setForumsHeaderDetails] = useState(null);
  const [userAskQuestionsModalPopup, setUserAskQuestionsModalPopUp] = useState(false);
  const [studentPurchasedCourseDetails, setStudentPurchaseCourseDetails] = useState();
  const [forumsInterrogate, setForumsInterrogate] = useState();
  const [forumId, setForumId] = useState(0);

  useEffect(() => {
    const fetchPurchasedCourses = async () => {
      try {
        const res = await axiosInstance.get("/course/purchased");
        setStudentPurchaseCourseDetails(res?.data?.data?.data);
      } catch (error) {
        console.error("Error fetching purchased courses:", error);
      } finally {
        setFetchStatusJustAddedCourse(false);
      }
    };

    fetchPurchasedCourses();
  }, []);


  useEffect(() => {
    fetchUserForumPosts();
  }, []);

  const fetchUserForumPosts = async () => {
    try {
      const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/forum`);
      setForumsInterrogate(res?.data?.data);
    } catch (error) {
      console.error("Error fetching forum posts:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const forumAskQueryActionHandler = () => {
    setUserAskQuestionsModalPopUp(!userAskQuestionsModalPopup);
  };
  const handleViewProgram = (course) => {
    const slug = slugify(course.CourseName);
    // const id = course.ID;
    // navigate(`/${slug}/${id}`, { state: { course: course } });
    navigate(`/${slug}`, { state: { course: course } });

  };
  return (
    <div className="container-wrapper">
      <div className="dashboard-container-new">
        <div>
          <p>Community</p>
          {forumsHeaderDetails && (
            <p className="text-sm text-gray-500">{forumsHeaderDetails}</p>
          )}
        </div>
        <div className="flex flex-col md:flex-row md:items-center gap-4 mt-4 md:mt-0">
          {/* <select className="border border-gray-200 rounded px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200">
            <option value="">By Courses</option>
            <option value="0">Artificial Intelligence</option>
            <option value="1">Machine Learning</option>
          </select>
          <select className="border border-gray-200 rounded px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200">
            <option value="">Latest First</option>
            <option value="0">1 week ago</option>
            <option value="1">1 month ago</option>
          </select> */}
          <button
            className="bg-white text-[#264b82] px-6 py-2 rounded-lg shadow transition"
            onClick={forumAskQueryActionHandler}
          >
            Create New Post
          </button>
        </div>
      </div>
      <div className="mt-6 flex flex-col md:flex-row gap-6">
        <div className="flex-1">
          <div>
            {isloading ? (
              <Loading />
            ) : forumsInterrogate && forumsInterrogate.length > 0 ? (
              forumsInterrogate.map((item) => (
                <PostComments
                  setForumsInterrogate={setForumsInterrogate}
                  element={item}
                  setForumsHeaderDetails={setForumsHeaderDetails}
                  studentPurchasedCourseDetails={studentPurchasedCourseDetails}
                  fetchUserForumPosts={fetchUserForumPosts}
                  forumId={forumId}
                  setForumId={setForumId}
                />
              ))
            ) : (
              <div className="flex justify-center items-center h-40">
                <span className="text-gray-400 text-lg">No Data Found</span>
              </div>
            )}
          </div>
        </div>

        <div className="w-full md:w-1/3 space-y-6">
          <div className="bg-white rounded-xl shadow p-4 mb-6">
            <p className="font-semibold text-gray-700 mb-3">Most Relevant Courses for You</p>
            {fetchStatusJustAddedCourse && (
              <div className="flex justify-center py-4">
                <Loading />
              </div>
            )}
            {studentPurchasedCourseDetails &&
              studentPurchasedCourseDetails.length > 0 &&
              studentPurchasedCourseDetails
                .slice(0, dataIndex)
                .map((ele, index) => (
                  <div className="flex items-center justify-between py-2 border-b border-gray-100" key={index} onClick={() => handleViewProgram(ele)}>
                    <div>
                      <p className="font-medium text-gray-800">{`${ele.CourseName.substring(0, 25)}...`}</p>
                      <p className="text-xs text-gray-500">{ele.instructorName}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-xs text-gray-400">{ele.Duration} hrs</p>
                      <p className="text-xs text-gray-400">$ {ele.EnrollmentFee}</p>
                    </div>
                  </div>
                ))}
            {studentPurchasedCourseDetails &&
              studentPurchasedCourseDetails.length > 5 && (
                <div
                  className="text-blue-600 text-sm mt-2 cursor-pointer hover:underline"
                  onClick={() =>
                    setDataIndex(
                      studentPurchasedCourseDetails && dataIndex === 5
                        ? studentPurchasedCourseDetails.length
                        : 5
                    )
                  }
                >
                  {dataIndex === 5 ? "View All" : "View Less"}
                </div>
              )}
          </div>
          {/* <div className="bg-white rounded-xl shadow p-4">
            <p className="font-semibold text-gray-700 mb-3">Event Calendar</p>
            <DashboardCalendar />
          </div> */}
        </div>

      </div>
      {userAskQuestionsModalPopup && (
        // <OverlayContainer>
        <Modal isOpen={userAskQuestionsModalPopup} onClose={forumAskQueryActionHandler}>
          <ReplyModal
            studentPurchasedCourseDetails={studentPurchasedCourseDetails}
            getForumRecords={fetchUserForumPosts}
            userAskQuestionsModalPopup={userAskQuestionsModalPopup}
            forumAskQueryActionHandler={forumAskQueryActionHandler}
            fetchUserForumPosts={fetchUserForumPosts}
            forumId={forumId}
            setForumId={setForumId}
          />
        </Modal>
        // </OverlayContainer>
      )}
    </div>
  );
}
